<div class="container brands">
    <div class="brands__head">
        <h3>Professional Alliances & Engagements:</h3>
    </div>

    <owl-carousel-o #owl class="brands__carousel" [options]="customOptions2" (mouseover)="pauseCarousel()"
        (mouseleave)="playCarousel()">
        <ng-container *ngFor="let slide of slidesStore">
            <ng-template carouselSlide>
                <a class="brand-card" [href]="slide.url" target="_blank" rel="noopener">
                    <img class="brand-card__img" [src]="slide.src" [alt]="slide.alt" [title]="slide.title" />
                </a>
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</div>